export const API_ENDPOINTS = {
  // Common API's
  LOGOUT: {
    url: "/logout",
    failureMessage: "There was a problem logging out.",
  },
  REGISTER: {
    url: "/register",
    failureMessage: "Could not create your account.",
  },
  RESET_PASSWORD: (token, accountType) => ({
    url: `/api/Reset/${token}/${accountType}`,
    failureMessage: "There was an error resetting your account.",
  }),
  FETCH_USER_EMAIL_ACCOUNTS: {
    url: "/api/FetchUserEmailAccounts",
    failureMessage: "Could not retrieve your email accounts.",
  },
  LOGIN: {
    url: "/login",
    failureMessage: "Could not log you in.",
  },
  GENERATE_QR_CODE_FOR_2FA: {
    url: "/api/generateQRCodeFor2FA",
    failureMessage: "Could not generate a QR code.",
  },
  VERIFY_REGISTRATION_OF_2FA: {
    url: "/api/verifyRegistrationOf2FA",
    failureMessage: "Could not verify 2FA registration.",
  },
  LOGIN_VERIFICATION_CHALLENGE_2FA: {
    url: "/api/loginVerificationChallenge2FA",
    failureMessage: "There was a problem with 2FA.",
  },

  // Admin API's
  LIST_ALL_ACTOR_DETAILS: {
    url: "/api/listAllActorDetails",
    failureMessage: "Could not retrieve the actor list.",
  },
  UPDATE_CLOSING_BALANCE_BULK: {
    url: "/api/UpdateClosingBalanceInBulk",
    failureMessage: "There was a problem updating balances.",
  },
  DOWNLOAD_CLOSING_BALANCE_TEMPLATE: {
    url: "/api/DownloadUploadClosingBalanceTemplate",
    failureMessage: "Could not download the template.",
  },
  UPDATE_RU_CONFIG_TEMPLATE: {
    url: "/api/UpdateRUConfigTemplate",
    failureMessage: "Could not update the template.",
  },
  INSERT_LEDGER_CONFIG_TEMPLATE: {
    url: "/api/InsertLedgerConfigTemplate",
    failureMessage: "Could not insert the template.",
  },
  LIST_SANITIZE_RULE: {
    url: "/api/listSanitizeRule",
    failureMessage: "Could not retrieve sanitize rules.",
  },
  LIST_LEDGER_CONFIG_TEMPLATE: (id) => ({
    url: `/api/ListLedgerConfigTemplate/?templateId=${id}`,
    failureMessage: "Could not retrieve the template.",
  }),
  LIST_ALL_LEDGER_CONFIG_TEMPLATES: {
    url: "/api/ListAllLedgerConfigTemplate",
    failureMessage: "There was a problem retrieving templates.",
  },
  LIST_RU_CONFIG_TEMPLATES_BY_ADMIN: {
    url: "/api/listRuConfigTemplatesByAdmin",
    failureMessage: "Could not retrieve the templates.",
  },
  DELETE_LEDGER_CONFIG_TEMPLATE: {
    url: "/api/deleteLedgerConfigTemplate",
    failureMessage: "Could not delete the template.",
  },
  DELETE_RU_CONFIG_TEMPLATE: {
    url: "/api/DeleteRuConfigTemplate",
    failureMessage: "Could not delete the template.",
  },
  GET_RU_CONFIG_TEMPLATE: {
    url: "/api/GetRuConfigTemplate",
    failureMessage: "Could not retrieve the template.",
  },
  COPY_RU_CONFIG_TEMPLATE_BY_ADMIN: {
    url: "/api/copyRUConfigTemplateByAdmin",
    failureMessage: "Could not copy the template.",
  },
  LIST_OWN_LEDGER: {
    url: "/api/ListOwnLedger",
    failureMessage: "Could not retrieve the ledger.",
  },
  LIST_BUSINESS_PARTNER_LEDGER: {
    url: "/api/ListBusinessPartnerLedger",
    failureMessage: "Could not retrieve the ledger.",
  },
  DELETE_OWN_LEDGER: {
    url: "/api/DeleteOwnLedger",
    failureMessage: "Could not delete the ledger.",
  },
  DELETE_BUSINESS_PARTNER_LEDGER: {
    url: "/api/DeleteBusinessPartnerLedger",
    failureMessage: "Could not delete the ledger.",
  },
  ADD_PAYMENT_DETAILS_BULK: {
    url: "/api/AddPaymentDetailsInBulk",
    failureMessage: "There was a problem adding payment details.",
  },
  GET_PAYMENT_DETAILS_BULK_UPLOAD_EXCEL_TEMPLATE: {
    url: "/api/GetPaymentDetailsBulkUploadExcelTemplate",
    failureMessage: "Could not download the template.",
  },
  LIST_ALL_OWN_BUSINESS_PARTNER_MAPPINGS_BY_ADMIN: {
    url: "/api/ListAllOwnBusinessPartnerMappingsByAdmin",
    failureMessage: "There was a problem retrieving mappings.",
  },
  DELETE_OWN_BUSINESS_PARTNER_MAPPING: {
    url: "/api/DeleteOwnBusinessPartnerMapping",
    failureMessage: "Could not delete the mapping.",
  },
  ADD_ACTOR_USER_MAPPING: {
    url: "/api/AddActorUserMapping",
    failureMessage: "Could not add the mapping.",
  },
  LIST_LEDGER: {
    url: "/api/ListLedger",
    failureMessage: "Could not retrieve the ledger.",
  },
  DELETE_SAP_DATA: {
    url: "/api/DeleteSapData",
    failureMessage: "Could not delete the SAP data.",
  },
  LIST_TALLY_LEDGER_BY_ADMIN: {
    url: "/api/ListTallyLedgerByAdmin",
    failureMessage: "Could not retrieve the ledger.",
  },
  GET_TALLY_PROGRESS: {
    url: "/api/GetTallyProgress",
    failureMessage: "Could not get the progress.",
  },
  LIST_TALLY_COMPANY_BY_ADMIN: {
    url: "/api/ListTallyCompanyByAdmin",
    failureMessage: "Could not retrieve the company list.",
  },
  GET_TALLY_METRICS: {
    url: "/api/GetTallyMetrics",
    failureMessage: "Could not retrieve the metrics.",
  },
  LIST_TALLY_ERRORS: {
    url: "/api/ListTallyErrors",
    failureMessage: "Could not retrieve the error list.",
  },
  LIST_TALLY_ACCEPTED_VOUCHER_TYPES_BY_ADMIN: {
    url: "/api/ListTallyAcceptedVoucherTypesByAdmin",
    failureMessage: "Could not retrieve accepted voucher types.",
  },
  POST_ACCEPTED_TALLY_VOUCHER_TYPES: {
    url: "/api/PostAcceptedTallyVoucherTypes",
    failureMessage: "Could not update voucher types.",
  },
  LIST_TALLY_VOUCHER: {
    url: "/api/ListTallyVocuher",
    failureMessage: "Could not retrieve the voucher list.",
  },
  LIST_TALLY_RAW_VOUCHER_BY_ADMIN: {
    url: "/api/ListTallyRawVoucherByAdmin",
    failureMessage: "Could not retrieve vouchers.",
  },
  ADD_UNPAID_INVOICES_IN_BULK: {
    url: "/api/AddUnpaidInvoicesInBulk",
    failureMessage: "There was a problem adding invoices.",
  },
  GET_UNPAID_INVOICES_BULK_UPLOAD_EXCEL_TEMPLATE: {
    url: "/api/GetUnpaidInvoicesBulkUploadExcelTemplate",
    failureMessage: "Could not download the template.",
  },
  LIST_ALL_ACTORS: {
    url: "/api/listAllActors",
    failureMessage: "Could not retrieve the actor list.",
  },
  LIST_ALL_USERS: {
    url: "/api/ListAllUsers",
    failureMessage: "Could not retrieve the user list.",
  },
  DELETE_ACTORS: {
    url: "/api/DeleteActors",
    failureMessage: "Could not delete actors.",
  },
  CREATE_MFA_MAPPING_FOR_ACTOR: {
    url: "/api/createMFAMappingForActor",
    failureMessage: "Could not create MFA mapping.",
  },
  DELETE_MFA_MAPPING_FOR_ACTOR: {
    url: "/api/deleteMFAMappingForActor",
    failureMessage: "Could not delete MFA mapping.",
  },
  REAUTHENTICATE_USER_2FA: {
    url: "/api/reAuthenticateUser2FA",
    failureMessage: "Could not re-authenticate with 2FA.",
  },
  GET_PARTNER_COMMUNICATION_FEEDBACK_IN_EXCEL: {
    url: "/api/partnerCommunication/FeedbackInExcel",
    failureMessage: "Could not retrieve feedback.",
  },
  GET_PARTNER_COMMUNICATION_METRICS: {
    url: "/api/partnerCommunication/GetPCMetrics",
    failureMessage: "Could not retrieve metrics.",
  },
  GET_RU_TEMPLATE_TRACKING: {
    url: "/api/GetRuTemplateTracking",
    failureMessage: "Could not retrieve tracking data.",
  },
  DOWNLOAD_SELECTED_REPORT: (apiUrl) => ({
    url: `/api/${apiUrl}`,
    failureMessage: "Could not download report.",
  }),
  GET_TASKS_REPORT: {
    url: "/api/tickets/GetReport",
    failureMessage: "Could not retrieve the report.",
  },

  //Dispute resolution -> Closure tracker
  GET_DR_TICKET_STATUS: {
    url: "/api/tickets/GetDRTicketStatus",
    failureMessage: "Could not retrieve ticket statuses.",
  },
  LIST_ALL_USERS_DR_EMAIL: {
    url: "/api/DisputeResolutionEmail/ListAllUsers",
    failureMessage: "Could not retrieve the user list.",
  },
  LIST_ALL_BUSINESS_PARTNERS_DR_EMAIL: {
    url: "/api/DisputeResolutionEmail/ListAllBusinessPartner",
    failureMessage: "Could not retrieve the partner list.",
  },
  GET_DISPUTE_RESOLUTION_REPORT: {
    url: "/api/tickets/GetDisputeResolutionReport",
    failureMessage: "Could not retrieve the report.",
  },
  UPDATE_OWN_AND_BUSINESS_PARTNER_MAPPING_CATEGORIES: {
    url: "/api/UpdateOwnAndBusinessPartnerMappingCategories",
    failureMessage: "Could not update categories.",
  },
  LIST_DYNAMIC_CONTENT_PARTNER_COMMUNICATION: {
    url: "/api/partnerCommunication/ListDynamicContent",
    failureMessage: "Could not retrieve content.",
  },
  LIST_USER_EMAIL_TEMPLATE_PARTNER_COMMUNICATION: {
    url: "/api/partnerCommunication/ListUserEmailTemplate",
    failureMessage: "Could not retrieve templates.",
  },
  GET_BULK_EMAIL_STATUS_DR_EMAIL: {
    url: "/api/DisputeResolutionEmail/GetBulkEmailStatus",
    failureMessage: "Could not retrieve email status.",
  },
  REFRESH_STATUS_DR_EMAIL: {
    url: "/api/DisputeResolutionEmail/RefreshStatus",
    failureMessage: "Could not refresh status.",
  },
  IS_STATUS_FETCHED_DR_EMAIL: {
    url: "/api/DisputeResolutionEmail/IsStatusFetched",
    failureMessage: "Could not check status.",
  },
  //partner master
  ADD_DESIGNATIONS: {
    url: "/api/AddDesignations",
    failureMessage: "Could not add designations.",
  },
  ADD_BUSINESS_PARTNER_USER_WITH_EMAIL_SETTING: {
    url: "/api/AddBusinessPartnerUserWithEmailSetting",
    failureMessage: "Could not add business partner user with email setting.",
  },
  ADD_BUSINESS_PARTNER_USERS_IN_BULK: {
    url: "/api/AddBusinessPartnerUsersInBulk",
    failureMessage: "Could not add business partner users.",
  },
  LIST_INVALID_EMAILS: {
    url: "/api/ListInvalidEmails",
    failureMessage: "Could not retrieve invalid emails.",
  },
  LIST_POTENTIALLY_INVALID_EMAILS: {
    url: "/api/ListPotentiallyInvalidEmails",
    failureMessage: "Could not retrieve potentially invalid emails.",
  },
  SUBMIT_EDITED_EMAIL: {
    url: "/api/SubmitEditedEmail",
    failureMessage: "Could not submit the edited email.",
  },
  DOWNLOAD_INVALID_EMAILS_REPORT: {
    url: "/api/DownloadInvalidEmailsReport",
    failureMessage: "Could not download the report.",
  },
  LIST_BUSINESS_PARTNER_USERS: {
    url: "/api/ListBusinessPartnerUsers",
    failureMessage: "Could not retrieve business partner users.",
  },
  DELETE_BUSINESS_PARTNER_USER: {
    url: "/api/DeleteBusinessPartnerUser",
    failureMessage: "Could not delete business partner user.",
  },
  LIST_ALL_BUSINESS_PARTNERS_FOR_PARTNER_MASTER: {
    url: "/api/ListAllBusinessPartnersForPartnerMaster",
    failureMessage: "Could not retrieve business partners.",
  },
  LIST_ALL_BUSINESS_PARTNER_CONTACTS: {
    url: "/api/ListAllBusinessPartnerContacts",
    failureMessage: "Could not retrieve business partner contacts.",
  },
  GET_BUSINESS_PARTNER_USER_BULK_UPLOAD_EXCEL_TEMPLATE: {
    url: "/api/GetBusinessPartnerUserBulkUploadExcelTemplate",
    failureMessage: "Could not download the template.",
  },
  LIST_ALL_DESIGNATION: {
    url: "/api/ListAllDesignation",
    failureMessage: "Could not retrieve designations.",
  },
  UPLOAD_CATEGORIES_IN_BULK: {
    url: "/api/UploadCategoriesInBulk",
    failureMessage: "Could not upload categories.",
  },
  GET_CATEGORIES_BULK_UPLOAD_EXCEL_TEMPLATE: {
    url: "/api/GetCategoriesBulkUploadExcelTemplate",
    failureMessage: "Could not download the template.",
  },
  //recon settings
  GET_CLIENT_TYPE: {
    url: "/api/GetClientType",
    failureMessage: "Could not retrieve client type.",
  },
  UPDATE_CLIENT_TYPE: {
    url: "/api/UpdateClientType",
    failureMessage: "Could not update client type.",
  },
  GET_CUSTOMISED_SETTING: {
    url: "/api/GetCustomisedSetting",
    failureMessage: "Could not retrieve customized setting.",
  },
  UPDATE_RECONCILE_FUNCTION_SETTING: {
    url: "/api/UpdateReconcileFunctionSetting",
    failureMessage: "Could not update reconcile function setting.",
  },
  UPDATE_REVERSAL_FUNCTION_SETTING: {
    url: "/api/UpdateReversalFunctionSetting",
    failureMessage: "Could not update reversal function setting.",
  },
  GET_RECON_SETTINGS: {
    url: "/api/Recon/GetReconSettings",
    failureMessage: "Could not retrieve reconciliation settings.",
  },
  UPLOAD_RECON_SETTINGS: {
    url: "/api/Recon/UploadReconSettings",
    failureMessage: "Could not upload reconciliation settings.",
  },
  GET_CUSTOM_SUMMARY_DESCRIPTION: {
    url: "/api/getCustomSummaryDescription",
    failureMessage: "Could not retrieve custom summary description.",
  },
  INSERT_CUSTOM_SUMMARY_DESCRIPTION: {
    url: "/api/insertCustomSummaryDescription",
    failureMessage: "Could not insert custom summary description.",
  },
  LIST_EMAIL_AUTO_RESET_SETTING: {
    url: "/api/ListEmailAutoResetSetting",
    failureMessage: "Could not retrieve email auto-reset settings.",
  },
  UPDATE_EMAIL_AUTO_RESET_SETTING: {
    url: "/api/UpdateEmailAutoResetSetting",
    failureMessage: "Could not update email auto-reset setting.",
  },
  UPDATE_COLUMNS_COLOR: {
    url: "/api/recon/UpdateColumnsColor",
    failureMessage: "Could not update column colors.",
  },
  SET_DEFAULT_DOWNLOAD_SETTINGS: {
    url: "/api/recon/SetDefaultDownloadSettings",
    failureMessage: "Could not set default download settings.",
  },
  ADD_COLUMNS_IN_OWN_VS_BP_SHEET: {
    url: "/api/recon/AddColumnsInOwnVsBpSheet",
    failureMessage: "Could not add columns.",
  },
  ADD_COLUMNS_IN_RECONCILIATION_SUMMARY: {
    url: "/api/recon/AddColumnsInRecociliationSummary",
    failureMessage: "Could not add columns.",
  },
  GET_COLUMNS_COLOR: {
    url: "/api/recon/GetColumnsColor",
    failureMessage: "Could not retrieve column colors.",
  },
  GET_DEFAULT_DOWNLOAD_SETTINGS: {
    url: "/api/recon/GetDefaultDownloadSettings",
    failureMessage: "Could not retrieve default download settings.",
  },
  GET_EXTRA_COLUMNS_IN_EXCEL_SHEET: {
    url: "/api/recon/GetExtraColumnsInExcelSheet",
    failureMessage: "Could not retrieve extra columns.",
  },
  GET_ACCOUNTING_TOLERANCE_FOR_RECONCILIATION: {
    url: "/api/GetAccountingToleranceForReconciliation",
    failureMessage: "Could not retrieve accounting tolerance.",
  },
  UPDATE_ACCOUNTING_TOLERANCE_FOR_RECONCILIATION: {
    url: "/api/UpdateAccountingToleranceForReconciliation",
    failureMessage: "Could not update accounting tolerance.",
  },
  LIST_USER_EMAIL_SETTING: {
    url: "/api/partnerCommunication/ListUserEmailSetting",
    failureMessage: "Could not retrieve user email settings.",
  },
  GET_AUTHORISATION_CODE_URL: {
    url: "/api/authenticationRoute/GetAuthorisationCodeUrl",
    failureMessage: "Could not retrieve authorization code URL.",
  },
  LIST_RECON_SUMMARY_ACCOUNTING_SETTING: {
    url: "/api/ListReconSummaryAccountingSetting",
    failureMessage: "Could not retrieve reconciliation summary settings.",
  },
  UPDATE_RECON_SUMMARY_TYPE: {
    url: "/api/UpdateReconSummaryType",
    failureMessage: "Could not update reconciliation summary type.",
  },
  LIST_RECON_SUMMARY_ACCOUNTING_SETTINGS_FOR_UI: {
    url: "/api/ListReconSummaryAccountingSettingsForUI",
    failureMessage: "Could not retrieve reconciliation summary settings.",
  },
  INSERT_RECON_SUMMARY_ACCOUNTING_SETTING: {
    url: "/api/InsertReconSummaryAccountingSetting",
    failureMessage: "Could not insert reconciliation summary setting.",
  },
  UPDATE_OUT_OF_PERIOD_SETTING: {
    url: "/api/UpdateOutOfPeriodSetting",
    failureMessage: "Could not update out-of-period setting.",
  },
  UPDATE_AMOUNT_ENTRY_TYPE: {
    url: "/api/updateAmountEntryType",
    failureMessage: "Could not update amount entry type.",
  },
  //workflow
  DOWNLOAD_BULK_CREATE_TASKS_TEMPLATE: {
    url: "/api/tickets/DownloadBulkCreateTasksTemplate",
    failureMessage: "Could not download the template.",
  },
  CREATE_TASKS_IN_BULK: {
    url: "/api/tickets/CreateTicketInBulk",
    failureMessage: "Could not create tasks.",
  },
  UPDATE_TASK_STATUS_IN_BULK: {
    url: "/api/tickets/UpdateTicketStatusInBulk",
    failureMessage: "Could not update task statuses.",
  },
  ADD_TASK_FOLLOW_UP: {
    url: "/api/tickets/AddTicketFollowUp",
    failureMessage: "Could not add task follow-up.",
  },
  UPDATE_TASK_REMARKS: {
    url: "/api/tickets/UpdateTicketRemarks",
    failureMessage: "Could not update task remarks.",
  },
  UPDATE_TICKET_STATUS: {
    url: "/api/tickets/UpdateTicketStatus",
    failureMessage: "Could not update task status.",
  },
  UPDATE_TICKET: {
    url: "/api/tickets/UpdateTicket",
    failureMessage: "Could not update task.",
  },
  LIST_ATTACHMENTS: (ticketId) => ({
    url: `/api/tickets/ListAttachments/${ticketId}`,
    failureMessage: "Could not retrieve attachments.",
  }),
  DOWNLOAD_ATTACHMENT: {
    url: "/api/tickets/DownloadAttachment",
    failureMessage: "Could not download attachment.",
  },
  DELETE_CUSTOM_ATTACHMENT: {
    url: "/api/tickets/DeleteCustomAttachment",
    failureMessage: "Could not delete attachment.",
  },
  UPLOAD_CUSTOM_ATTACHMENT: {
    url: "/api/tickets/UploadCustomAttachment",
    failureMessage: "Could not upload attachment.",
  },
  GET_TICKET_HISTORY: {
    url: "/api/tickets/GetTicketHistory",
    failureMessage: "Could not retrieve ticket history.",
  },
  UPDATE_BULK_TICKET: {
    url: "/api/tickets/UpdateBulkTicket",
    failureMessage: "Could not update tickets.",
  },
  GET_REPORT_FOR_ACCOUNT: (view) => ({
    url: `/api/tickets/GetReportForAccount?view=${view}`,
    failureMessage: "Could not retrieve the report.",
  }),

  //Recon MIS
  GET_RECON_INSIGHTS: {
    url: "/api/getReconInsights",
    failureMessage: "Could not retrieve reconciliation insights.",
  },
  ADD_AUTO_REPORT_TEMPLATE_MIS: {
    url: "/api/ClientReporting/AddAutoReportTemplateMIS",
    failureMessage: "Could not add the report template.",
  },
  UPDATE_AUTO_REPORT_TEMPLATE_MIS: {
    url: "/api/ClientReporting/UpdateAutoReportTemplateMIS",
    failureMessage: "Could not update the report template.",
  },
  TOGGLE_AUTO_REPORT_TEMPLATE_MIS: {
    url: "/api/ClientReporting/ToggleAutoReportTemplateMIS",
    failureMessage: "Could not toggle the report template.",
  },
  LIST_AUTO_REPORT_TEMPLATE_MIS: {
    url: "/api/ClientReporting/ListAutoReportTemplateMIS",
    failureMessage: "Could not retrieve report templates.",
  },
  LIST_AUTO_REPORT_MIS: {
    url: "/api/ClientReporting/ListAutoReportMIS",
    failureMessage: "Could not retrieve reports.",
  },
  GET_USER_EMAILS: {
    url: "/api/ClientReporting/GetUserEmails",
    failureMessage: "Could not retrieve user emails.",
  },
  TRIGGER_AUTO_REPORT_TEMPLATE_MIS: {
    url: "/api/ClientReporting/TriggerAutoReportTemplateMIS",
    failureMessage: "Could not trigger the report template.",
  },
  LIST_OWN_TALLY_COMPANIES_FOR_RECON: {
    url: "/api/ListOwnTallyCompaniesForRecon",
    failureMessage: "Could not retrieve Tally companies.",
  },
  GET_CLOSURE_TRACKER_DATA: {
    url: "/api/MIS/GetClosureTrackerData",
    failureMessage: "Could not retrieve closure tracker data.",
  },
  GET_CLOSURE_TRACKER_OVERVIEW: {
    url: "/api/MIS/GetClosureTrackerOverview",
    failureMessage: "Could not retrieve closure tracker overview.",
  },
  UPDATE_STATUS_DONE_TRACKER: {
    url: "/api/MIS/UpdateStatusDoneTracker",
    failureMessage: "Could not update the status.",
  },
  UPDATE_REMARKS_TRACKER: {
    url: "/api/MIS/UpdateRemarksTracker",
    failureMessage: "Could not update remarks.",
  },
  DOWNLOAD_ACTIVITY_REPORT: (activityMonth, actorId, businessPartnerId) => ({
    url: `/api/download/${activityMonth}/${actorId}/${businessPartnerId}`,
    failureMessage: "Could not download the activity report.",
  }),
  UPLOAD_TRACKER_FILE: {
    url: "/api/MIS/UploadTrackerFile",
    failureMessage: "Could not upload the file.",
  },
  DOWNLOAD_TRACKER_FILE: {
    url: "/api/MIS/DownloadTrackerFile",
    failureMessage: "Could not download the file.",
  },
  DELETE_TRACKER_FILE: {
    url: "/api/MIS/DeleteTrackerFile",
    failureMessage: "Could not delete the file.",
  },
  UPLOAD_TRACKER_TARGET_EXCEL: {
    url: "/api/MIS/UploadTrackerTargetExcel",
    failureMessage: "Could not upload the file.",
  },
  GET_TRACKER_UPLOAD_EXCEL_TEMPLATE: {
    url: "/api/MIS/GetTrackerUploadExcelTemplate",
    failureMessage: "Could not download the template.",
  },
};
